import { observer } from 'mobx-react';
import { useMemo } from 'react';
import CopyToClipboardStore from '../../../../../../../../../CopyToClipboard/Store';
import CopyToClipboardReactions from '../../../../../../../../../CopyToClipboard/Store/Reactions';
import CopyToClipboardState from './CopyToClipboardState';

interface Props {
  copyText: string;
}

function CopyToClipboard({ copyText }: Props) {
  const copyToClipboardStore = useMemo(() => new CopyToClipboardStore(copyText), [copyText]);

  return (
    <div
      data-clipboard-text={copyText}
      className="bg-white border-1 mr-4 flex items-center rounded border-teal-600 text-teal-600 py-4 px-3 text-xs"
    >
      <CopyToClipboardState
        kind={copyToClipboardStore.state.kind}
        copying={copyToClipboardStore.copying}
      />
      <CopyToClipboardReactions store={copyToClipboardStore} />
    </div>
  );
}

export default observer(CopyToClipboard);
